import { createSelector } from 'reselect'
import * as R from 'ramda'
import {
  PAGE,
  FILE_TYPE
} from './constants'

const activeSelector = state => state.project.fileUpload.active
const pageSelector = state => state.project.fileUpload.page
const fileTypeSelector = state => state.project.fileUpload.fileType
const fileTypeLabelSelector = state => FILE_TYPE[fileTypeSelector(state)].label
const internalSelector = state => state.project.fileUpload.internal

const isUploadingSelector = createSelector(
  pageSelector,
  R.equals(PAGE.UPLOADING)
)

export {
  activeSelector,
  pageSelector,
  fileTypeSelector,
  fileTypeLabelSelector,
  isUploadingSelector,
  internalSelector
}
